module.exports = __webpack_public_path__ + "static/media/16.eead66d4.jpg";